import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { createFile_book_download_url_list } from '../../../services/File_book_download_url_listService'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

export default class File_book_download_url_listPageAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
      file_url: '', 
      filename: '', 
      issue_id: '', 
      date_created: '', 

      registerError: null,
      currentUser: null,
      isLoading: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();

    log.debug(user.displayName)

    this.setState({currentUser: user})
    // this.setState({owner_id: user.uid})
    // let uuidv4 = getUUIDV4()
    // this.setState({publisher_uuid: uuidv4})
    // this.setState({id_from_url: this.props.match.params.id_from_url})

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    let file_book_download_url_list = {
      
      file_url: this.state.file_url , 
      filename: this.state.filename , 
      issue_id: this.state.issue_id , 
      date_created: this.state.date_created , 
    }
    log.debug(file_book_download_url_list)

    try{
      let result = await createFile_book_download_url_list(file_book_download_url_list)
      log.debug('save success')
      // redirect to list view.
      this.props.history.push("/file_book_download_url_list")
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/file_book_download_url_list'>File_book_download_url_list</Link> ->
          Add
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }
          
          <div className="form-group">
            <label htmlFor="file_url" className="col-sm-2 control-label">file_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="file_url"
                value={this.state.file_url}
                onChange={this.handleInputChange}
                placeholder="file_url" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="filename" className="col-sm-2 control-label">filename:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="filename"
                value={this.state.filename}
                onChange={this.handleInputChange}
                placeholder="filename" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_id" className="col-sm-2 control-label">issue_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_id"
                value={this.state.issue_id}
                onChange={this.handleInputChange}
                placeholder="issue_id" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_created"
                value={this.state.date_created}
                onChange={this.handleInputChange}
                placeholder="date_created" />
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Add</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/File_book_download_url_listPage/File_book_download_url_listPageAdd.js